function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.553 18a2.695 2.695 0 01-2.696-2.696V2.696A2.695 2.695 0 013.553 0h19.304a2.695 2.695 0 012.696 2.696v12.608A2.695 2.695 0 0122.857 18H3.553zM22.962 1.8H3.55c-.495 0-.895.4-.895.896v12.608c0 .495.4.896.895.896h19.412c.495 0 .895-.4.895-.896V2.696c0-.495-.4-.896-.895-.896z",
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mail_svg__mail_svg__mask0",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 26,
  height: 18
}, /*#__PURE__*/React.createElement("path", {
  d: "M.857 15.304A2.695 2.695 0 003.553 18h19.304a2.695 2.695 0 002.696-2.696V2.696A2.695 2.695 0 0022.857 0H3.553A2.695 2.695 0 00.857 2.696v12.608z",
  fill: "#DADADA"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mail_svg__mail_svg__mask0)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 13.49,
  y: -9.586,
  width: 15.867,
  height: 15.867,
  rx: 1,
  transform: "rotate(45 13.49 -9.586)",
  stroke: "#000",
  strokeWidth: 2
}));

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyNiAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjU1MyAxOEMyLjA2NDEzIDE4IDAuODU3NDIyIDE2Ljc5MzUgMC44NTc0MjIgMTUuMzA0NFYyLjY5NTU4QzAuODU3NDIyIDEuMjA2NzEgMi4wNjM4NyAwIDMuNTUzIDBIMjIuODU3NEMyNC4zNDYzIDAgMjUuNTUzIDEuMjA2NDUgMjUuNTUzIDIuNjk1NThWMTUuMzA0NEMyNS41NTMgMTYuNzkzMyAyNC4zNDY2IDE4IDIyLjg1NzQgMThIMy41NTNaTTIyLjk2MTggMS43OTk5N0gzLjU1MDM3QzMuMDU1NDMgMS43OTk5NyAyLjY1NDc5IDIuMjAwNzEgMi42NTQ3OSAyLjY5NTU1VjE1LjMwNDRDMi42NTQ3OSAxNS43OTkzIDMuMDU1NTIgMTYuMiAzLjU1MDM3IDE2LjJIMjIuOTYxOEMyMy40NTY4IDE2LjIgMjMuODU3NCAxNS43OTkyIDIzLjg1NzQgMTUuMzA0NFYyLjY5NTU1QzIzLjg1NzQgMi4yMDA2MiAyMy40NTY3IDEuNzk5OTcgMjIuOTYxOCAxLjc5OTk3WiIgZmlsbD0iYmxhY2siLz4KPG1hc2sgaWQ9Im1hc2swIiBtYXNrLXR5cGU9ImFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMjYiIGhlaWdodD0iMTgiPgo8cGF0aCBkPSJNMC44NTc0MjIgMTUuMzA0NEMwLjg1NzQyMiAxNi43OTM1IDIuMDY0MTMgMTggMy41NTMgMThIMjIuODU3NEMyNC4zNDY2IDE4IDI1LjU1MyAxNi43OTMzIDI1LjU1MyAxNS4zMDQ0VjIuNjk1NThDMjUuNTUzIDEuMjA2NDUgMjQuMzQ2MyAwIDIyLjg1NzQgMEgzLjU1M0MyLjA2Mzg3IDAgMC44NTc0MjIgMS4yMDY3MSAwLjg1NzQyMiAyLjY5NTU4VjE1LjMwNDRaIiBmaWxsPSIjREFEQURBIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMCkiPgo8cmVjdCB4PSIxMy40OTAyIiB5PSItOS41ODU3OSIgd2lkdGg9IjE1Ljg2NyIgaGVpZ2h0PSIxNS44NjciIHJ4PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxMy40OTAyIC05LjU4NTc5KSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+CjwvZz4KPC9zdmc+Cg==";
export { SvgMail as ReactComponent };